import { HeartHandshake, Award, MapPin } from "lucide-react";
import { useLang } from "../context/LanguageContext";

const IMG = "https://images.pexels.com/photos/7345474/pexels-photo-7345474.jpeg";

const content = {
  en: {
    story: "Doktor Ke Rumah was founded with a simple mission: to bring quality medical care to patients who find it difficult to travel to clinics. From elderly parents needing chronic screenings to post-surgery patients requiring wound care, our team of MMC-registered doctors serves families across the entire Klang Valley.",
    mission: "Our Mission", missionText: "To make professional healthcare accessible, comfortable and dignified — right at home.",
    values: [
      { icon: HeartHandshake, title: "Compassionate Care", desc: "We treat every patient like family, with patience and respect." },
      { icon: Award, title: "Clinical Excellence", desc: "All doctors are MMC-registered with verified qualifications and experience." },
      { icon: MapPin, title: "Local Commitment", desc: "Dedicated to the Lembah Klang community, from Klang to Putrajaya." },
    ],
  },
  ms: {
    story: "Doktor Ke Rumah ditubuhkan dengan misi mudah: membawa penjagaan perubatan berkualiti kepada pesakit yang sukar ke klinik. Daripada ibu bapa warga emas yang memerlukan saringan kronik hingga pesakit pasca pembedahan yang memerlukan rawatan luka, pasukan doktor berdaftar MMC kami melayani keluarga di seluruh Lembah Klang.",
    mission: "Misi Kami", missionText: "Menjadikan penjagaan kesihatan profesional mudah diakses, selesa dan bermaruah — terus di rumah.",
    values: [
      { icon: HeartHandshake, title: "Penjagaan Penyayang", desc: "Kami melayan setiap pesakit seperti keluarga, dengan sabar dan hormat." },
      { icon: Award, title: "Kecemerlangan Klinikal", desc: "Semua doktor berdaftar MMC dengan kelayakan dan pengalaman yang disahkan." },
      { icon: MapPin, title: "Komitmen Tempatan", desc: "Berdedikasi kepada komuniti Lembah Klang, dari Klang hingga Putrajaya." },
    ],
  },
};

export default function About() {
  const { lang, t } = useLang();
  const c = content[lang];
  return (
    <div data-testid="about-page" className="max-w-7xl mx-auto px-4 sm:px-6 py-16">
      <h1 className="text-4xl sm:text-5xl font-semibold tracking-tight text-slate-900 mb-10">{t("about.title")}</h1>
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center mb-20">
        <p className="text-base md:text-lg text-slate-600 leading-relaxed">{c.story}</p>
        <img src={IMG} alt="Home care" className="rounded-2xl h-80 w-full object-cover shadow-md" />
      </div>
      <div className="bg-primary rounded-2xl p-10 sm:p-14 text-white mb-16">
        <h2 className="font-heading text-2xl sm:text-3xl font-semibold mb-3">{c.mission}</h2>
        <p className="text-blue-100 text-base md:text-lg max-w-2xl">{c.missionText}</p>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
        {c.values.map(({ icon: Icon, title, desc }) => (
          <div key={title} className="bg-white rounded-2xl border border-slate-200 p-8">
            <span className="inline-flex w-12 h-12 rounded-xl bg-emerald-50 items-center justify-center mb-5">
              <Icon className="w-6 h-6 text-emerald-600" />
            </span>
            <h3 className="font-heading text-lg font-semibold text-slate-900 mb-2">{title}</h3>
            <p className="text-sm text-slate-500 leading-relaxed">{desc}</p>
          </div>
        ))}
      </div>
    </div>
  );
}
